// extracted by mini-css-extract-plugin
export default {"background":"styles_background__n+JHk","box":"styles_box__-SbSK","buttons":"styles_buttons__VZP0X"};